import { get, isEmpty } from 'lodash';
import { DOMParser } from '@xmldom/xmldom';
import xpath from 'xpath';

export function selectXPath(dataPath, xml) {
  const dom = new DOMParser().parseFromString(xml);

  // if certain XPath functions are in use, don't use namespaces
  if (/\bnamespace-uri\s*\(|\blocal-name\s*\(/.test(dataPath)) {
    return xpath.select(dataPath, dom);
  }

  // search for a default namespace in XML and register it with the prefix "_default"
  const namespaces = {};
  const defaultXmlnsMatch = xml.match(/\bxmlns="(.*?)"/);
  const defaultNamespace = '_default';
  let effectiveDataPath;

  if (defaultXmlnsMatch && defaultXmlnsMatch[1]) {
    namespaces[defaultNamespace] = defaultXmlnsMatch[1];

    // prepend the prefix "_default" to all non-prefixed elements in dataPath
    const elementNamePattern = '[A-Za-z_][\\w-.]*';
    const boundaryPattern = '[^\\w-.:]';
    // const boundaryPattern = '/|\\[|\\]|\\(|\\)|>|<|=|\\s|\\|';
    const regex = new RegExp(
      `(${boundaryPattern}|^)(${elementNamePattern})(?=${boundaryPattern}|$)`,
      'g',
    );
    effectiveDataPath = dataPath.replace(regex, `$1${defaultNamespace}:$2`);
  } else {
    effectiveDataPath = dataPath;
  }

  // gather the namespaces declared on the root element
  const rootAttributes = get(dom, 'documentElement.attributes');

  if (rootAttributes) {
    for (let i = rootAttributes.length - 1; i > -1; i--) {
      const attribute = rootAttributes[i];

      if (attribute.prefix === 'xmlns' && attribute.localName) {
        namespaces[attribute.localName] = attribute.nodeValue;
      }
    }
  }

  const select = isEmpty(namespaces) ? xpath.select : xpath.useNamespaces(namespaces);
  return select(effectiveDataPath, dom);
}
